"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
var _typeof = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/typeof.js");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.weak-map");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _user = require("@/api/user");
var _auth = require("@/utils/auth");
var _router = _interopRequireWildcard(require("@/router"));
var _apolloClient = require("@/apollo/apolloClient");
var _clientQuery = require("@/apollo/queries/client-query");
var _recruitmentQuery = require("@/apollo/queries/recruitment-query");
var _DocumentCategory = require("@/lib/enum/DocumentCategory");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
// import { login, logout, getInfo } from '@/api/user'

var firebase = require('firebase');
require('firebase/functions');
require('firebase/auth');
var state = {
  token: (0, _auth.getToken)(),
  name: '',
  avatar: '',
  introduction: '',
  roles: [],
  currentClient: [],
  user: []
};
var mutations = {
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_INTRODUCTION: function SET_INTRODUCTION(state, introduction) {
    state.introduction = introduction;
  },
  SET_NAME: function SET_NAME(state, name) {
    state.name = name;
  },
  SET_AVATAR: function SET_AVATAR(state, avatar) {
    state.avatar = avatar;
  },
  SET_ROLES: function SET_ROLES(state, roles) {
    state.roles = roles;
  },
  SET_CURRENT_CLIENT: function SET_CURRENT_CLIENT(state, client) {
    state.currentClient = client.map(function (client) {
      return client;
    });
  },
  SET_FIREBASE_USER: function SET_FIREBASE_USER(state, user) {
    state.user = user;
  }
};
var actions = {
  // user login
  login: function () {
    var _login = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref, userInfo) {
      var commit, id, password, loginFunctions, loginRespond;
      return regeneratorRuntime.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            commit = _ref.commit;
            id = userInfo.id, password = userInfo.password;
            loginFunctions = firebase.app().functions('asia-northeast1');
            loginRespond = loginFunctions.httpsCallable('clientLogin');
            _context3.next = 1;
            return loginRespond({
              client_id: id,
              password: password
            }).then(/*#__PURE__*/function () {
              var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(result) {
                var client;
                return regeneratorRuntime.wrap(function (_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      if (!(result.data.code === 200)) {
                        _context2.next = 2;
                        break;
                      }
                      _context2.next = 1;
                      return firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                        return regeneratorRuntime.wrap(function (_context) {
                          while (1) switch (_context.prev = _context.next) {
                            case 0:
                              _context.next = 1;
                              return firebase.auth().signInWithCustomToken(result.data.login_token).catch(function (error) {
                                return Promise.reject('認証に失敗しました。(' + error.data.code + ')');
                              });
                            case 1:
                              return _context.abrupt("return", _context.sent);
                            case 2:
                            case "end":
                              return _context.stop();
                          }
                        }, _callee);
                      }))).catch(function (error) {
                        return Promise.reject('認証に失敗しました。(' + error.code + ')');
                      });
                    case 1:
                      _context2.next = 3;
                      break;
                    case 2:
                      return _context2.abrupt("return", Promise.reject(result.data.message));
                    case 3:
                      _context2.next = 4;
                      return _apolloClient.apolloClient.query({
                        query: _clientQuery.CLIENT_QUERY,
                        variables: {
                          uid: result.data.uid
                        },
                        fetchPolicy: 'no-cache'
                      }).catch(function (error) {
                        console.error('error' + error);
                      });
                    case 4:
                      client = _context2.sent;
                      commit('SET_TOKEN', 'admin-token');
                      commit('SET_CURRENT_CLIENT', client.data.client_user);
                      (0, _auth.setToken)('admin-token');
                      (0, _auth.setUUID)(client.data.client_user[0].uid);
                      (0, _auth.setClientID)(client.data.client_user[0].id);
                    case 5:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2);
              }));
              return function (_x3) {
                return _ref2.apply(this, arguments);
              };
            }()).catch(function (error) {
              console.log(error);
              return Promise.reject(error);
            });
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    function login(_x, _x2) {
      return _login.apply(this, arguments);
    }
    return login;
  }(),
  setFirebaseUser: function () {
    var _setFirebaseUser = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref4, user) {
      var commit;
      return regeneratorRuntime.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            commit = _ref4.commit;
            commit('SET_FIREBASE_USER', user);
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    function setFirebaseUser(_x4, _x5) {
      return _setFirebaseUser.apply(this, arguments);
    }
    return setFirebaseUser;
  }(),
  // get user info
  getInfo: function () {
    var _getInfo2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(_ref5) {
      var commit, state, res, res1, res2, res3, res4, res5;
      return regeneratorRuntime.wrap(function (_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            commit = _ref5.commit, state = _ref5.state;
            _context5.next = 1;
            return _apolloClient.apolloClient.query({
              query: _clientQuery.GET_CLIENT_DOC_RELEASE_COUNT,
              variables: {
                client_id: (0, _auth.getClientID)(),
                file_type: _DocumentCategory.DocumentCategory.ClientDocumentType.Contract.val
              },
              fetchPolicy: 'no-cache'
            });
          case 1:
            res = _context5.sent;
            (0, _auth.setContractCount)(res.data.client_file_link_aggregate.aggregate.count);
            _context5.next = 2;
            return _apolloClient.apolloClient.query({
              query: _clientQuery.GET_CLIENT_DOC_RELEASE_COUNT,
              variables: {
                client_id: (0, _auth.getClientID)(),
                file_type: _DocumentCategory.DocumentCategory.ClientDocumentType.ConfirmationInvoice.val
              },
              fetchPolicy: 'no-cache'
            });
          case 2:
            res1 = _context5.sent;
            (0, _auth.setInvoiceCount)(res1.data.client_file_link_aggregate.aggregate.count);
            _context5.next = 3;
            return _apolloClient.apolloClient.query({
              query: _clientQuery.GET_CLIENT_DOC_RELEASE_COUNT,
              variables: {
                client_id: (0, _auth.getClientID)(),
                file_type: _DocumentCategory.DocumentCategory.ClientDocumentType.ConfirmationAttendance.val
              },
              fetchPolicy: 'no-cache'
            });
          case 3:
            res2 = _context5.sent;
            (0, _auth.setAttendanceCount)(res2.data.client_file_link_aggregate.aggregate.count);
            _context5.next = 4;
            return _apolloClient.apolloClient.query({
              query: _clientQuery.GET_CLIENT_DOC_RELEASE_COUNT,
              variables: {
                client_id: (0, _auth.getClientID)(),
                file_type: _DocumentCategory.DocumentCategory.ClientDocumentType.ConfirmationLaborNotice.val
              },
              fetchPolicy: 'no-cache'
            });
          case 4:
            res3 = _context5.sent;
            (0, _auth.setLaborCount)(res3.data.client_file_link_aggregate.aggregate.count);
            _context5.next = 5;
            return _apolloClient.apolloClient.query({
              query: _recruitmentQuery.GET_RECRUITMENT_ADDSTAFF_COUNT,
              variables: {
                uuid: (0, _auth.getUUID)()
              },
              fetchPolicy: 'no-cache'
            });
          case 5:
            res4 = _context5.sent;
            (0, _auth.setRecruitmentAddStaffCount)(res4.data.recruitment_info_aggregate.aggregate.count);
            _context5.next = 6;
            return _apolloClient.apolloClient.query({
              query: _clientQuery.GET_CLIENT_CHAT_COUNT,
              variables: {
                client_uid: (0, _auth.getUUID)()
              },
              fetchPolicy: 'no-cache'
            });
          case 6:
            res5 = _context5.sent;
            (0, _auth.setClientChatCount)(res5.data.client_message_aggregate.aggregate.sum.unread_count);
            return _context5.abrupt("return", new Promise(function (resolve, reject) {
              (0, _user.getInfo)(state.token).then(function (response) {
                var data = response.data;
                if (!data) {
                  reject('Verification failed, please Login again.');
                }
                var roles = data.roles,
                  name = data.name,
                  avatar = data.avatar,
                  introduction = data.introduction;

                // roles must be a non-empty array
                if (!roles || roles.length <= 0) {
                  reject('getInfo: roles must be a non-null array!');
                }
                commit('SET_ROLES', roles);
                commit('SET_NAME', name);
                commit('SET_AVATAR', avatar);
                commit('SET_INTRODUCTION', introduction);
                resolve(data);
              }).catch(function (error) {
                reject(error);
              });
            }));
          case 7:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    function getInfo(_x6) {
      return _getInfo2.apply(this, arguments);
    }
    return getInfo;
  }(),
  // user logout
  logout: function logout(_ref6) {
    var commit = _ref6.commit,
      state = _ref6.state,
      dispatch = _ref6.dispatch;
    return new Promise(function (resolve, reject) {
      (0, _user.logout)(state.token).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              commit('SET_TOKEN', '');
              commit('SET_ROLES', []);
              (0, _auth.removeToken)();
              (0, _auth.removeUUID)();
              (0, _auth.removeClientID)();
              (0, _auth.removeRecruitmentID)();
              (0, _auth.removeStaffID)();
              (0, _auth.removeRecruitmentMessageID)();
              (0, _auth.removeClientDocumentID)();
              (0, _auth.removeMessageMode)();
              (0, _auth.removeContractCount)();
              (0, _auth.removeInvoiceCount)();
              (0, _auth.removeAttendanceCount)();
              (0, _auth.removeLaborCount)();
              (0, _auth.removeRecruitmentAddStaffCount)();
              (0, _auth.removeClientChatCount)();
              (0, _router.resetRouter)();
              // await firebase.auth().signOut()
              // reset visited views and cached views
              // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
              // dispatch('tagsView/delAllViews', null, { root: true })

              resolve();
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))).catch(function (error) {
        console.log(error);
        reject(error);
      });
    });
  },
  // remove token
  resetToken: function resetToken(_ref8) {
    var commit = _ref8.commit;
    return new Promise(function (resolve) {
      commit('SET_TOKEN', '');
      commit('SET_ROLES', []);
      commit('SET_CURRENT_CLIENT', []);
      (0, _auth.removeToken)();
      (0, _auth.removeUUID)();
      (0, _auth.removeClientID)();
      (0, _auth.removeRecruitmentID)();
      (0, _auth.removeStaffID)();
      (0, _auth.removeRecruitmentMessageID)();
      (0, _auth.removeClientDocumentID)();
      (0, _auth.removeMessageMode)();
      (0, _auth.removeContractCount)();
      (0, _auth.removeInvoiceCount)();
      (0, _auth.removeAttendanceCount)();
      (0, _auth.removeLaborCount)();
      (0, _auth.removeRecruitmentAddStaffCount)();
      (0, _auth.removeClientChatCount)();
      resolve();
    });
  },
  // dynamically modify permissions
  changeRoles: function changeRoles(_ref9, role) {
    var commit = _ref9.commit,
      dispatch = _ref9.dispatch;
    return new Promise(/*#__PURE__*/function () {
      var _ref0 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee7(resolve) {
        var token, _yield$dispatch, roles, accessRoutes;
        return regeneratorRuntime.wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              token = role + '-token';
              commit('SET_TOKEN', token);
              (0, _auth.setToken)(token);
              _context7.next = 1;
              return dispatch('getInfo');
            case 1:
              _yield$dispatch = _context7.sent;
              roles = _yield$dispatch.roles;
              (0, _router.resetRouter)();

              // generate accessible routes map based on roles
              _context7.next = 2;
              return dispatch('permission/generateRoutes', roles, {
                root: true
              });
            case 2:
              accessRoutes = _context7.sent;
              // dynamically add accessible routes
              _router.default.addRoutes(accessRoutes);

              // reset visited views and cached views
              dispatch('tagsView/delAllViews', null, {
                root: true
              });
              resolve();
            case 3:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      return function (_x7) {
        return _ref0.apply(this, arguments);
      };
    }());
  }
};
var _default = exports.default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};